import type {PublicMethodUtils} from '@wix/document-services-types'

export default function (publicMethodUtils: PublicMethodUtils) {
    const {
        extensionPublicAPI: {dataManipulation}
    } = publicMethodUtils
    return {
        methods: {
            mobileAlgo: {
                run: dataManipulation('mobileAlgo.run'),
                runForPage: dataManipulation('mobileAlgo.runForPage')
            }
        }
    }
}
